<div class="pagination">
  <gd-pagination-active-page-label [offset]="offset" [limit]="limit" [total]="total"> </gd-pagination-active-page-label>
  <gd-pagination-page-selector
    [offset]="offset"
    [limit]="limit"
    [total]="total"
    (offsetChange)="onOffsetChange($event)"
  ></gd-pagination-page-selector>
</div>
